import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('_fk_rbac_role__id', ['fkRbacRoleId'], {})
@Index('_userId', ['userId', 'fkRbacRoleId'], { unique: true })
@Entity('_rbac_role__user')
export class RbacRoleUserEntity extends BaseEntity {
	@Column('int', { name: '_userId', nullable: true, unsigned: true })
	public userId!: number | null;

	@Column('int', { name: '_fk__rbac_role__id', nullable: true, unsigned: true })
	public fkRbacRoleId!: number | null;
}
